import { LinkIcon } from "@akord/addon-icons";

export const shareSnackbarViewProps = {
  text: "The link to this image was copied to your clipboard",
  Icon: LinkIcon
}
